function precisionRound(number, precision) {
	const factor = 10 ** precision;
	return (Math.round(number * factor)) / factor;
}

export { precisionRound };

export default {
	methods: {
		precisionRound,
	},
};



// WEBPACK FOOTER //
// ./src/mixins/precision-round.js